import React from "react";

// const urbaniaFleet = [
//   {
//     img: "/images/gallery/1.jpg",
//     name: "Force Urbania 12 Seater",
//     desc:
//       "12 Seater Urbania on rent in Pune is ideal for family trips, airport transfers, and small group travel with premium comfort and safety.",
//   },
//   {
//     img: "/images/gallery/2.jpg",
//     name: "Force Urbania 14 Seater",
//     desc:
//       "14 Seater Urbania on rent in Pune is perfect for weddings, corporate travel, and outstation tours with luxury interiors and spacious seating.",
//   },
//   {
//     img: "/images/gallery/3.jpg",
//     name: "Force Urbania 16 Seater",
//     desc:
//       "16 Seater Urbania on rent in Pune offers extra space and comfort, suitable for group tours, religious trips, and long-distance journeys.",
//   },
//   {
//     img: "/images/gallery/4.jpg",
//     name: "Luxury Urbania",
//     desc:
//       "Luxury Urbania on rent in Pune comes with push-back seats, AC, charging points, and smooth suspension for premium group travel.",
//   },
//   {
//     img: "/images/gallery/5.jpg",
//     name: "Corporate Urbania",
//     desc:
//       "Corporate Urbania on rent in Pune is best for office travel, IT company transport, conferences, and employee movement.",
//   },
//   {
//     img: "/images/gallery/6.jpg",
//     name: "Tourist Bus",
//     desc:
//       "Tourist Bus on rent in Pune is designed for sightseeing, Maharashtra tours, and outstation travel with experienced drivers.",
//   },
// ];

const urbaniaFleet = [
  {
    img: "/images/gallery/1.jpg",
    name: "Force Urbania 9 Seater",
    desc:
      "9 Seater Urbania on rent in Pune is perfect for premium small group travel, VIP guests, and executive trips with extra legroom and comfort.",
  },
  {
    img: "/images/gallery/2.jpg",
    name: "Force Urbania 10 Seater",
    desc:
      "10 Seater Urbania on rent in Pune offers a balance of luxury and space, ideal for family outings and business travel.",
  },
  {
    img: "/images/gallery/3.jpg",
    name: "Force Urbania 13 Seater",
    desc:
      "13 Seater Urbania on rent in Pune is suitable for mid-size group travel, functions, and comfortable outstation journeys.",
  },
  {
    img: "/images/gallery/4.jpg",
    name: "Force Urbania High Roof",
    desc:
      "High Roof Urbania on rent in Pune provides extra headroom, making it comfortable for long-distance travel and tall passengers.",
  },
  {
    img: "/images/gallery/5.jpg",
    name: "Force Urbania Low Roof",
    desc:
      "Low Roof Urbania on rent in Pune is ideal for city travel, offering easy accessibility and smooth navigation in urban areas.",
  },
  {
    img: "/images/gallery/6.jpg",
    name: "Urbania for Airport Transfer",
    desc:
      "Urbania for airport transfer in Pune ensures timely pickups, ample luggage space, and a comfortable ride for passengers.",
  },
  {
    img: "/images/services/6.jpg",
    name: "Urbania for Wedding",
    desc:
      "Urbania for wedding transport in Pune is perfect for guest movement, baraat travel, and family functions with luxury seating.",
  },
  {
    img: "/images/services/2.jpg",
    name: "Urbania for Outstation",
    desc:
      "Urbania for outstation travel from Pune is ideal for long trips with comfortable seating, AC, and experienced drivers.",
  },
];

const OurFleet = () => {
  return (
   <>
   <div
      className="breadcumb-wrapper"
      
      data-overlay="black"
      data-opacity="3"
    >
      <div className="container">
        <div className="breadcumb-content text-center">
          <h1 className="breadcumb-title">Our Fleets</h1>
        </div>
      </div>
    </div>

   
   
   
    <section className=" bg-light" id="our-fleet">
      <div className="container">
        {/* Heading */}
       

        {/* Fleet Cards */}
        <div className="row gy-4">
          {urbaniaFleet.map((item, index) => (
            <div className="col-xl-4 col-lg-4 col-md-6" key={index}>
              <div className="fleet-card text-center">
                <div className="fleet-img">
                  <img src={item.img} alt={item.name} />
                </div>

                <div className="fleet-content">
                  <h3 className="fleet-title">{item.name}</h3>
                  <p className="fleet-text">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
   </>
  );
};

export default OurFleet;
